'use client';

import { IconButton } from '../button';

interface MaskedIconProps {
  isMasked: boolean;
  onClick: () => void;
}

export const MaskedIcon = ({ onClick, isMasked }: MaskedIconProps) => {
  return <IconButton onClick={onClick} size={'small'} iconType={isMasked ? 'eye-slash' : 'eye'} />;
};
